import React, { useState, forwardRef, useImperativeHandle, useEffect } from 'react';
import { Alert } from 'antd';
const AlertComponent = forwardRef((props, ref) => {
    const [attributeState, setAttributeState] = useState(props.state);
    const [attributeValue, setAttributeValue] = useState(props.message);
    const [attributeType, setAttributeType] = useState("info");
    const [attributeTitle, setAttributeTitle] = useState("Information");


    useImperativeHandle(ref, () => ({
        updateStateAttributes(state, type, title, value) {
            setAttributeState(state)
            setAttributeType(type)
            setAttributeValue(value);
            setAttributeTitle(title);
        }
    }));

    if (attributeState === null || !attributeState) {
        return;
    }

    const handleClose = ()=>{
        console.log(handleClose);
        setAttributeState(false);
    }

    return <Alert
        message={attributeTitle}
        description={attributeValue}
        type={attributeType}
        showIcon closable onClose={handleClose}
    />
});

export default AlertComponent;